import React, { useState } from "react";
import { Link } from "react-router-dom";
import SocialLogin from "./SocialLogin";
import LoginWithEmail from "./LoginWithEmail";
import LoginWithPhone from "./LoginWithPhone";
import { useDispatch } from "react-redux";
import { setModal } from "../../../features/modal/ModalSlice";

const Login = () => {
  const [loginVia, setLoginVia] = useState("EMAIL");

  const dispatch = useDispatch();

  const toggleLoginVia = () => {
    if (loginVia === "EMAIL") setLoginVia("PHONE");
    else setLoginVia("EMAIL");
  };

  const handleSignupPopUp = () => {
    dispatch(setModal({ type: "SIGNUP" }));
  };

  return (
    <div>
      <h2>Login</h2>

      {loginVia === "EMAIL" ? <LoginWithEmail /> : <LoginWithPhone />}

      <div className="d-flex justify-content-center">
        <hr className="w-50 mx-2" />
        <p>or</p>
        <hr className="w-50 mx-2" />
      </div>

      <SocialLogin />

      <div className="d-flex justify-content-center">
        <hr className="w-50 mx-2" />
        <p>or</p>
        <hr className="w-50 mx-2" />
      </div>
      <button className="btn btn-primary custom-btn-full my-3" onClick={() => toggleLoginVia()}>
        <div></div>
        Sign in With {loginVia === "EMAIL" ? "Phone" : "Email"}
        <div></div>
      </button>

      <div className="text-center text-muted small">
        Create an account <Link onClick={handleSignupPopUp}>Register</Link>
      </div>
    </div>
  );
};

export default Login;
